import NotFound from "src/components/errors/NotFoundPage";
import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { setupRouterSsrQueryIntegration } from "@tanstack/react-router-ssr-query";
import { routeTree } from "./routeTree.gen";
import { DefaultCatchBoundary } from "./components/DefaultCatchBoundary";
import * as Sentry from "@sentry/tanstackstart-react";

export function getRouter() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: true,
      },
    },
  });

  const router = createRouter({
    routeTree,
    context: { queryClient },
    defaultPreload: "intent",
    defaultErrorComponent: DefaultCatchBoundary,
    defaultNotFoundComponent: () => <NotFound />,
    notFoundMode: "root",
    scrollRestoration: true,
  });
  setupRouterSsrQueryIntegration({
    router,
    queryClient,
  });

  if (!router.isServer && import.meta.env.PROD) {
    Sentry.init({
      dsn: "https://2c5fed8db0ffa45bba24d6908c02c27a@o4504674414690304.ingest.us.sentry.io/4508264230748160",
      // Adds request headers and IP for users, for more info visit:
      // https://docs.sentry.io/platforms/javascript/guides/tanstackstart-react/configuration/options/#sendDefaultPii
      sendDefaultPii: true,
      integrations: [
        //  performance
        // Sentry.tanstackRouterBrowserTracingIntegration(router),
        //  performance
        //  session-replay
        // Sentry.replayIntegration(),
        //  session-replay
        //  user-feedback
        // Sentry.feedbackIntegration({
        // Additional SDK configuration goes in here, for example:
        // colorScheme: "system",
        // }),
        //  user-feedback
      ],
      //  logs
      // Enable logs to be sent to Sentry
      enableLogs: true,
      //  logs
      //  performance
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for tracing.
      // We recommend adjusting this value in production.
      // Learn more at https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
      tracesSampleRate: 1.0,
      //  performance
      //  session-replay
      // Capture Replay for 10% of all sessions,
      // plus for 100% of sessions with an error.
      // Learn more at https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      //  session-replay
    });
  }

  return router;
}

declare module "@tanstack/react-router" {
  interface Register {
    // ssr: true;
    router: Awaited<ReturnType<typeof getRouter>>;
  }
}
